module.exports = {
	"classes": [
		"b2b",
		"header-dark"
	],
	"title": "Easier Enterprise Identity Management for your Business Partners",
	"metas": {
		"description": "Give your customers enterprise identity integration, frictionless SSO across your products and adaptive authentication with MFA and Anomaly Detection. All of this with a flip of a switch."
	},
	"opengraph": {
		"og:title": "Easier Enterprise Identity Management for your Business Partners",
		"og:description": "Give your customers enterprise identity integration, frictionless SSO across your products and adaptive authentication with MFA and Anomaly Detection. All of this with a flip of a switch.",
		"og:url": "https://auth0.com//b2b-enterprise-identity-management",
		"og:image": "https://cdn.auth0.com/website/assets/pages/b2b/img/b2b-share-card-46bd12cc43.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/assets/pages/b2b/img/b2b-share-card-46bd12cc43.png"
	},
	"twittercard": {
		"twitter:title": "Easier Enterprise Identity Management for your Business Partners",
		"twitter:description": "Give your customers enterprise identity integration, frictionless SSO across your products and adaptive authentication with MFA and Anomaly Detection. All of this with a flip of a switch.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/assets/pages/b2b/img/b2b-share-card-46bd12cc43.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/b2b/metadata.json
// module id = 1107
// module chunks = 0